import { apiClient } from '@/services/base'

import { IResetPasswordMultiTenantRequest } from './interfaces/request'
import {
  IResetPasswordMultiTenantResponse,
  IResetPasswordMultiTenantErrorResponse,
} from './interfaces/response'

export const ResetPasswordMultiTenantService = async (
  request: IResetPasswordMultiTenantRequest,
): Promise<IResetPasswordMultiTenantResponse> => {
  const response = await apiClient.patch(
    'api/PasswordReset/MultiTenant',
    {},
    {
      params: request,
    },
  )

  return response
}

export type {
  IResetPasswordMultiTenantRequest,
  IResetPasswordMultiTenantResponse,
  IResetPasswordMultiTenantErrorResponse,
}
